import { useNavigation } from "@react-navigation/native";
import { Colors, Text, View } from "react-native-ui-lib";
import {
  showColorPicker,
  useColorPickerListener,
} from "../../modules/point-of-sale/screens/ColorPickerScreen";
import { quickKeyColors } from "../../utilities/quick-keys";
import { ColorPicker } from "./components";

export type ColorPickerSelectorProps = {
  label?: string;
  defaultValue?: string;
  value: string;
  hexList?: string[];
  onChange: (color: string) => void;
};

export function ColorPickerSelector({
  label,
  defaultValue,
  value,
  hexList = [
    Colors.quickKeyAction,
    Colors.quickKeyBackground,
    ...Object.values(quickKeyColors).map((color) => color.background),
  ],
  onChange,
}: ColorPickerSelectorProps) {
  const navigation = useNavigation();

  useColorPickerListener(({ value: newValue }) => {
    onChange(newValue);
  }, []);

  const labelMarkup = label ? <Text>{label}</Text> : null;

  return (
    <View>
      {labelMarkup}
      <ColorPicker.Item
        hexCode={value}
        onPress={() => {
          showColorPicker(navigation, {
            defaultValue,
            value,
            hexList,
          });
        }}
      />
    </View>
  );
}

ColorPickerSelector.ColorPicker = ColorPicker;
